export const Logo = () => (
  <svg
    width="151"
    height="32"
    viewBox="0 0 151 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 3034">
      <path
        id="Vector"
        d="M0 31.5435V5.70999C0 4.72215 0.688494 3.8765 1.65388 3.66696L6.45837 2.63422V12.7446C7.68569 10.4396 9.6913 9.24974 12.6848 9.24974C17.4144 9.24974 20.2956 12.1684 20.2956 18.1702V31.551H13.7998V18.1702C13.7998 15.9027 12.6473 14.7502 10.5295 14.7502C7.9551 14.7502 6.49579 16.0973 6.49579 19.4424V31.551H0V31.5435Z"
        fill="#231F20"
      />
      <path
        id="Vector_2"
        d="M24.8681 8.00746V5.35826C24.8681 4.58744 25.4069 3.9214 26.1628 3.75676L31.3265 2.63422L31.3639 8.00746H24.8681Z"
        fill="#231F20"
      />
      <path
        id="Vector_3"
        d="M31.3639 9.70627H24.8681V31.5435H31.3639V9.70627Z"
        fill="#231F20"
      />
      <path
        id="Vector_4"
        d="M36.0561 31.5435V9.70626H41.3994L42.013 13.2011C43.1281 10.7764 45.246 9.24228 48.434 9.24228C51.622 9.24228 53.6651 10.6267 54.623 13.2011C56.1197 10.5519 58.5444 9.24228 61.5453 9.24228C66.6566 9.24228 69.5378 12.1609 69.5378 18.1628V31.5435H63.042V18.1628C63.042 15.8952 61.8896 14.7427 59.7717 14.7427C57.1973 14.7427 56.0448 15.8952 56.0448 19.2404V31.5435H49.5491V18.1628C49.5491 15.8952 48.3966 14.7427 46.2787 14.7427C43.7043 14.7427 42.5519 15.8952 42.5519 19.2404V31.5435H36.0561Z"
        fill="#231F20"
      />
      <path
        id="Vector_5"
        d="M98.5968 25.5042V30.2339C97.594 31.4238 95.4836 32 94.1365 32C91.5247 32 89.7137 30.8101 88.9055 28.6548C87.753 30.5407 85.7923 32 82.4097 32C75.8765 32 72.9129 27.5023 72.9129 20.6623C72.9129 13.8223 77.216 9.24228 83.9438 9.24228C86.3311 9.24228 88.5163 9.7811 90.4022 10.5893L90.8213 9.70626H94.8924V24.5463C94.8924 26.0879 95.6258 26.507 96.434 26.507C97.2422 26.507 97.7811 26.2002 98.5893 25.5042H98.5968ZM88.4041 22.159V15.319C87.289 14.855 86.0617 14.6305 84.7146 14.6305C81.2572 14.6305 79.7156 17.2797 79.7156 20.6623C79.7156 24.3517 81.0626 26.6193 84.3255 26.6193C87.2067 26.6193 88.3966 24.3143 88.3966 22.159H88.4041Z"
        fill="#231F20"
      />
      <path
        id="Vector_6"
        d="M101.051 25.6239V5.51541C101.051 4.63983 101.665 3.89147 102.518 3.70438L107.547 2.63422V24.5463C107.547 26.0879 108.281 26.507 109.081 26.507C109.882 26.507 110.428 26.2002 111.237 25.5042V30.2338C110.234 31.4237 108.123 32 106.776 32C103.124 32 101.051 29.695 101.051 25.6164V25.6239Z"
        fill="#231F20"
      />
      <path
        id="Vector_7"
        d="M113.699 25.6239V2.71656C113.699 1.93826 114.245 1.27222 115.001 1.10758L120.195 0V24.5463C120.195 26.0879 120.928 26.507 121.736 26.507C122.544 26.507 123.083 26.2002 123.891 25.5042V30.2339C122.889 31.4238 120.778 32 119.431 32C115.779 32 113.706 29.695 113.706 25.6165L113.699 25.6239Z"
        fill="#231F20"
      />
      <path
        id="Vector_8"
        d="M150.833 25.5042V30.2339C149.83 31.4238 147.719 32 146.372 32C143.76 32 141.949 30.8101 141.141 28.6548C139.989 30.5407 138.028 32 134.645 32C128.112 32 125.149 27.5023 125.149 20.6623C125.149 13.8223 129.452 9.24228 136.18 9.24228C138.559 9.24228 140.752 9.7811 142.638 10.5893L143.057 9.70626H147.128V24.5463C147.128 26.0879 147.862 26.507 148.662 26.507C149.463 26.507 150.009 26.2002 150.818 25.5042H150.833ZM140.647 22.159V15.319C139.532 14.855 138.305 14.6305 136.958 14.6305C133.5 14.6305 131.959 17.2797 131.959 20.6623C131.959 24.3517 133.306 26.6193 136.569 26.6193C139.45 26.6193 140.64 24.3143 140.64 22.159H140.647Z"
        fill="#231F20"
      />
    </g>
  </svg>
);
